<template>
 <Head>
    <title> Edit Personal Details | {{ $page.props.details.first_name }} | {{$page.props.details.surname}} | {{$page.props.appName}}</title>
    <meta name="description" :content="'Edit Personal Details' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl p-3 text-black">
      <div class="w-full flex">
        <div class="w-full">
          <h1 class="text-xl">
            Personal Details for {{ $page.props.details.first_name }}
            {{ $page.props.details.middle_name }}
            {{ $page.props.details.surname }}
          </h1>
        </div>
      </div>
        

      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Upload new staff image:</label>
            <input type="file" name="fileupload" ref="fileupload" class="block"   @change="handleFileUpload" accept="image/*">
        
           <img
          :src="url"
          v-if="url.length > 0"
          width="300"
          height="300"
          class="mt-2 px-8"
        />
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Username:</label>
            <input v-model="form.username" type="text" class="form-input"/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">First Name:</label>
            <input v-model="form.first_name" type="text" class="form-input"/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Middle Name:</label>
            <input v-model="form.middle_name" type="text" class="form-input"/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Surname:</label>
            <input v-model="form.surname" type="text" class="form-input" />
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Site:</label>
            <select name="" id="" class="form-select" v-model="form.site_id">
              <option :value="site.id" :key="site.id" v-for="site in sites">{{site.site_name}}</option>
            </select>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Department:</label>
            <select name="" id="" class="form-select" v-model="form.department_id">
              <option :value="department.id" :key="department.id" v-for="department in departments">{{department.department_name}}</option>
            </select>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Phone Number:</label>
            <input v-model="form.phone_number" type="text" class="form-input"/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">National Insurance Number:</label>
            <input v-model="form.national_insurance_number" type="text" class="form-input"/>
        </div>
      <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Driving License Number:</label>
            <input v-model="form.driving_license_number" type="text" class="form-input"/>
      </div>
       <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Email:</label>
            <input v-model="form.email" type="text" class="form-input"/>
      </div>


       <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Is Admin:</label>
            <input type="checkbox" v-model="form.is_admin" :checked="form.is_admin == 1">
      </div>

  <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Is Viewer:</label>
            <input type="checkbox" v-model="form.is_viewer" :checked="form.is_viewer == 1">
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">New password:</label>
            <p class="text-xs">Please enter a new password below, if you're resetting it..</p>
            <input v-model="form.password" type="password" class="form-input" />

      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Re-enter password:</label>
            <input v-model="password" type="password" class="form-input" />
            <p class="text-xs font-semibold text-red-400" v-if="password!==this.form.password">Please ensure both of the passwords are the same!</p>
      </div>
      </div>
        <button class="bg-red-400 text-white font-bold p-2 ml-6 mt-3 float-left" @click="deletedata()">DELETE STAFF MEMBER</button>

        <button class="bg-black text-white font-bold p-2 mr-6 mt-3 float-right" @click="submitForm()" :disabled="form.processing">EDIT DETAILS</button>

    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  props : { 
    id : String,
    details : Object,
    sites : Object,
    departments : Object,
  },
  components : {Head},
      data() {
        return {
            password : '',
            url : '',
            form: this.$inertia.form({
                username : this.details.username,
                email : this.details.email,
                is_admin : this.details.is_admin,
                is_viewer : this.details.is_viewer,
                password : null,
                driving_license_number:  this.details.driving_license_number,
                national_insurance_number : this.details.national_insurance_number,
                phone_number : this.details.phone_number,
                site_id : this.details.site_id,
                department_id : this.details.department_id,
                surname : this.details.surname,
                middle_name: this.details.middle_name,
                first_name : this.details.first_name,
                avatar : null
            }),
        };
    },
    methods : {
      submitForm() {
            this.form.post("/admin/personal-details/" + this.id);
      },
     handleFileUpload(e) {
      const file = e.target.files[0];
      this.form.avatar = file;
      this.url = URL.createObjectURL(file);

    },
    deletedata() {
            if (confirm("Are you sure you want to delete this staff member? - Be aware they will be removed completely!")) {
                this.$inertia.delete("/admin/personal-details/" + this.id);
            }
        }
    }
};
</script>